import { render, staticRenderFns } from "./LayoutBlank.vue?vue&type=template&id=f68e0bfc&scoped=true"
import script from "./LayoutBlank.vue?vue&type=script&lang=js"
export * from "./LayoutBlank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68e0bfc",
  null
  
)

export default component.exports